import _ from 'lodash';

export const getIsButtonEnabled = (data, initialData, errors) => {
  if (Object.values(errors).some((e) => e) || _.isEqual(data, initialData)) {
    return false;
  }

  return true;
};
